const maskPatternOne = '## #### ####';
const placeholderPatternOne = '__ ____ ____';
const maskPatternTwo = '### ### ###';
const placeholderPatternTwo = '___ ___ ___';
const maskPatternThree = '## ### ####';
const placeholderPatternThree = '__ ___ ____';
const phoneFormats = {
  AR: {
    countryName: 'Argentina',
    countryPhoneCode: '+54',
    mask: '###-###-####',
    minLength: 10,
    placeholder: '___-___-____',
  },
  AT: {
    countryName: 'Austria',
    countryPhoneCode: '+43',
    mask: '####-######',
    minLength: 10,
    placeholder: '____-______',
  },
  AU: {
    countryName: 'Australia',
    countryPhoneCode: '+61',
    mask: maskPatternOne,
    minLength: 10,
    placeholder: placeholderPatternOne,
  },
  BE: {
    countryName: 'Belgium',
    countryPhoneCode: '+32',
    mask: '#### ### ###',
    minLength: 10,
    placeholder: '____ ___ ___',
  },
  BN: {
    countryName: 'Brunei',
    countryPhoneCode: '+673',
    mask: '###-####',
    minLength: 7,
    placeholder: '___-____',
  },
  CA: {
    countryName: 'Canada',
    countryPhoneCode: '+1',
    mask: '###-###-####',
    minLength: 10,
    placeholder: '___-___-____',
  },
  CL: {
    countryName: 'Chile',
    countryPhoneCode: '+56',
    mask: '########',
    minLength: 8,
    placeholder: '________',
  },
  CO: {
    countryName: 'Colombia',
    countryPhoneCode: '+57',
    mask: '###-###-####',
    minLength: 10,
    placeholder: '___-___-____',
  },
  CZ: {
    countryName: 'Czech Republic',
    countryPhoneCode: '+420',
    mask: '###-###-###',
    minLength: 9,
    placeholder: '___-___-___',
  },
  DE: {
    countryName: 'Germany',
    countryPhoneCode: '+49',
    mask: '##############',
    minLength: 10,
    placeholder: '______________',
  },
  DK: {
    countryName: 'Denmark',
    countryPhoneCode: '+45',
    mask: '## ## ## ##',
    minLength: 8,
    placeholder: '__ __ __ __',
  },
  ES: {
    countryName: 'Spain',
    countryPhoneCode: '+34',
    mask: '### ######',
    minLength: 9,
    placeholder: '___ ______',
  },
  FI: {
    countryName: 'Finland',
    countryPhoneCode: '+358',
    mask: '##### ### ## ##',
    minLength: 10,
    placeholder: '____ ___ __ __',
  },
  FR: {
    countryName: 'France',
    countryPhoneCode: '+33',
    mask: '### ## ## ##',
    minLength: 9,
    placeholder: '___ __ __ __',
  },
  GB: {
    countryName: 'United Kingdom',
    countryPhoneCode: '+44',
    mask: '###########',
    minLength: 11,
    placeholder: '___________',
  },
  HK: {
    countryName: 'Hong Kong',
    countryPhoneCode: '+852',
    mask: '####-####',
    minLength: 8,
    placeholder: '____-____',
  },
  HU: {
    countryName: 'Hungary',
    countryPhoneCode: '+36',
    mask: '(##) ###-####',
    minLength: 9,
    placeholder: '(__) ___-____',
  },
  ID: {
    countryName: 'Indonesia',
    countryPhoneCode: '+62',
    mask: '#############',
    minLength: 8,
    placeholder: '___________',
  },
  IE: {
    countryName: 'Ireland',
    countryPhoneCode: '+353',
    mask: '### ### ####',
    minLength: 10,
    placeholder: '___ __ ____',
  },
  IL: {
    countryName: 'Israel',
    countryPhoneCode: '+44',
    mask: '### ### ####',
    minLength: 10,
    placeholder: '___ ___ ____',
  },
  IS: {
    countryName: 'Iceland',
    countryPhoneCode: '+354',
    mask: '### ####',
    minLength: 7,
    placeholder: '___ ____',
  },
  IT: {
    countryName: 'Italy',
    countryPhoneCode: '+39',
    mask: '#### ### ###',
    minLength: 10,
    placeholder: '____ ___ ___',
  },
  JP: {
    countryName: 'Japan',
    countryPhoneCode: '+81',
    mask: maskPatternOne,
    minLength: 10,
    placeholder: placeholderPatternOne,
  },
  KR: {
    countryName: 'South Korea',
    countryPhoneCode: '+82',
    mask: '## #### ####',
    minLength: 6,
    placeholder: placeholderPatternOne,
  },
  LU: {
    countryName: 'Luxembourg',
    countryPhoneCode: '+352',
    mask: maskPatternTwo,
    minLength: 9,
    placeholder: placeholderPatternTwo,
  },
  MO: {
    countryName: 'Macau',
    countryPhoneCode: '+853',
    mask: '####-####',
    minLength: 8,
    placeholder: '____-____',
  },
  MX: {
    countryName: 'Mexico',
    countryPhoneCode: '+52',
    mask: maskPatternOne,
    minLength: 10,
    placeholder: placeholderPatternOne,
  },
  MY: {
    countryName: 'Malaysia',
    countryPhoneCode: '+60',
    mask: '###-########',
    minLength: 10,
    placeholder: '___-_________',
  },
  NC: {
    countryName: 'New Caledonia',
    countryPhoneCode: '+687',
    mask: '########',
    minLength: 6,
    placeholder: '________',
  },
  NL: {
    countryName: 'The Netherlands',
    countryPhoneCode: '+31',
    mask: '#########',
    minLength: 9,
    placeholder: '_________',
  },
  NO: {
    countryName: 'Norway',
    countryPhoneCode: '+47',
    mask: '############',
    minLength: 8,
    placeholder: '____________',
  },
  NZ: {
    countryName: 'New Zealand',
    countryPhoneCode: '+64',
    mask: maskPatternOne,
    minLength: 10,
    placeholder: placeholderPatternOne,
  },
  PE: {
    countryName: 'Peru',
    countryPhoneCode: '+51',
    mask: '###-###-###',
    minLength: 9,
    placeholder: placeholderPatternTwo,
  },
  PF: {
    countryName: 'French Polynesia',
    countryPhoneCode: '+689',
    mask: '## ## ## ##',
    minLength: 6,
    placeholder: '__ __ __ __',
  },
  PH: {
    countryName: 'Philippines',
    countryPhoneCode: '+63',
    mask: '####-#######',
    minLength: 11,
    placeholder: '____-_______',
  },
  PL: {
    countryName: 'Poland',
    countryPhoneCode: '+48',
    mask: '## ### ## ##',
    minLength: 9,
    placeholder: '__ ___ __ __',
  },
  PT: {
    countryName: 'Portugal',
    countryPhoneCode: '+351',
    mask: maskPatternThree,
    minLength: 9,
    placeholder: placeholderPatternThree,
  },
  RO: {
    countryName: 'Romania',
    countryPhoneCode: '+40',
    mask: maskPatternThree,
    minLength: 9,
    placeholder: placeholderPatternThree,
  },
  RU: {
    countryName: 'Russia',
    countryPhoneCode: '+7',
    mask: '### ### ## ##',
    minLength: 9,
    placeholder: '___ ___ __ __',
  },
  SE: {
    countryName: 'Sweden',
    countryPhoneCode: '+46',
    mask: '#### #### ## ##',
    minLength: 9,
    placeholder: '____ ____ __ __',
  },
  SG: {
    countryName: 'Singapore',
    countryPhoneCode: '+65',
    mask: '####-####',
    minLength: 8,
    placeholder: '____-____',
  },
  SK: {
    countryName: 'Slovakia',
    countryPhoneCode: '+421',
    mask: '###-######',
    minLength: 9,
    placeholder: '___-______',
  },
  TH: {
    countryName: 'Thailand',
    countryPhoneCode: '+66',
    mask: maskPatternThree,
    minLength: 9,
    placeholder: placeholderPatternThree,
  },
  TW: {
    countryName: 'Taiwan',
    countryPhoneCode: '+886',
    mask: maskPatternTwo,
    minLength: 8,
    placeholder: placeholderPatternTwo,
  },
  UA: {
    countryName: 'Ukraine',
    countryPhoneCode: '+380',
    mask: '(###) ### ####',
    minLength: 10,
    placeholder: '___ ___ ____',
  },
  US: {
    countryName: 'United States',
    countryPhoneCode: '+1',
    mask: '(###) ###-####',
    minLength: 10,
    placeholder: '___ ___-____',
  },
  VN: {
    countryName: 'Vietnam',
    countryPhoneCode: '+84',
    mask: '###-#######',
    minLength: 9,
    placeholder: '____ ____ ___',
  },
  ZA: {
    countryName: 'South Africa',
    countryPhoneCode: '+27',
    mask: '###-###-####',
    minLength: 9,
    placeholder: '___-___-____',
  },
};

export default phoneFormats;
